import { createRoot } from "react-dom/client";
import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import { ThemeProvider } from "./providers/ThemeProvider";
import ErrorBoundary from "./components/ErrorBoundary";

// Initialize axe-core for accessibility testing in development
if (import.meta.env.DEV) {
  import('@axe-core/react').then(axe => {
    axe.default(React, ReactDOM, 1000);
  });
}

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <HelmetProvider>
      <ThemeProvider defaultTheme="system" storageKey="libaddict-ui-theme">
        <App />
      </ThemeProvider>
    </HelmetProvider>
  </ErrorBoundary>
);
